
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary-terms",
      function () {
        return require("private-next-pages/dispensary-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary-terms"])
      });
    }
  